<script>
  import Image from "./Image.svelte";
  import Button from "./Button.svelte";
  import Slider from "../../Common/Slider.svelte";
  import {M} from "../../external";

  export let data, onChange;
</script>

<Image bind:data disable={["link", "width"]} />
<Slider
  min={10}
  max={1200}
  value={data.style.width || 310}
  step={10}
  suffix="px"
  clz="mt-5"
  sameLine={true}
  onChange={(val) => onChange("width", val)}
  label={M.IMAGE_WIDTH} />

<Button bind:data isCollapsable={true} isCollapsed={true} />
